<p-datepicker 
  [(ngModel)]="_value"
  (ngModelChange)="_onValueChange($event)"
  [styleClass]="styleClass"
  [inputStyleClass]="inputStyleClass"
  [maxDate]="maxDate"
  [minDate]="minDate"
  [inline]="inline"
  [disabledDates]="disabledDates"
  class="w-full"
  (onSelect)="onSelect.emit($event)"
  (onMonthChange)="onMonthChange.emit($event)"
  [dateFormat]="dateFormat"
  [placeholder]="placeholder"
  [showIcon]="showIcon"
  iconDisplay="input"
/>
